import { Asset } from "../Asset";
class Images {
    static Exists(src) {
        return this.els.has(src);
    }
    static Create(src) {
        const el = new Image();
        el.src = src;
        this.els.set(src, el);
        return el;
    }
    static Get(src) {
        return this.els.get(src);
    }
}
Images.els = new Map();
export class Sprite extends Asset {
    constructor(src, width, height, x, y, cropWidth, cropHeight) {
        super();
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
        this.cropWidth = cropWidth;
        this.cropHeight = cropHeight;
        if (Images.Exists(src)) {
            this.sprite = Images.Get(src);
        }
        else {
            this.sprite = Images.Create(src);
        }
    }
    draw(ctx, owner) {
        ctx.drawImage(this.sprite, this.x || 0, this.y || 0, this.cropWidth || this.width, this.cropHeight || this.height, owner.position.getX(), owner.position.getY(), this.width, this.height);
    }
}
//# sourceMappingURL=Sprite.js.map